/** Account set up header**/
export const ACCOUNT_SETUP_HEADING = "account-setup-label";
export const ACCOUNT_SETUP_PAGE_PROGRESS_VALUE = 50;
export const ACCOUNT_SETUP_COMPLETION_FRACTION = "2/4";

/** Field names **/
export const USER_NAME_FIELD_NAME = "userName";
export const PASSWORD_FIELD_NAME = "password";
export const CONFIRM_PASSWORD_FIELD_NAME = "confirmPassword";

/** Password Form API response descriptions **/
export const CANNOT_CONTAIN_DICTIONARY_WORDS =
  "CANNOT_CONTAIN_DICTIONARY_WORDS";
export const UNSECURE_PASSWORD = "UNSECURE_PASSWORD";
export const VALID_PASSWORD = "VALID_PASSWORD";
export const USERNAME_DOES_NOT_EXIST = "USERNAME_DOES_NOT_EXIST";
export const USERNAME_ALREADY_EXISTS = "USERNAME_ALREADY_EXISTS";
export const CANNOT_CONTAIN_OLD_PASSWORDS = "CANNOT_CONTAIN_OLD_PASSWORDS";

/** other **/
export const SUCCESS = "success";
export const ERROR = "error";
export const USER_TYPE_CONSUMER = "Consumer";
export const DEBOUNCE_TIME_VALUE = 3000;

/**error messages**/
export const USER_NAME_ALREADY_EXIST_ERROR_MESSAGE =
  "userName-already-exist-error-message";
export const PASSWORD_DICTIONARY_ERROR_MESSAGE =
  "password-cannot-contain-dictionary-words-error-message";
export const PASSWORD_UNSECURE_ERROR_MESSAGE =
  "password-unsecure-error-message";
export const PASSWORD_PREVIOUS_24_PASSWORDS_ERROR_MESSAGE =
  "password-cannot-be-one-of-previous-24-passwords";
